var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2, H4 } from "@irati/ui/src/Typography";
import DragAndDrop from "@irati/ui/src/DragAndDrop";
import Flex from "@irati/ui/src/Flex";
import { CircledConnector } from "./styled";
import FieldsRecap from "./FieldsRecap";
import DownloadCsvTemplate from "./DownloadCsvTemplate";
var AddPeopleCSV = /** @class */ (function (_super) {
    __extends(AddPeopleCSV, _super);
    function AddPeopleCSV() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddPeopleCSV.prototype.render = function () {
        var _a = this.props, onDrop = _a.onDrop, formatMessage = _a.formatMessage;
        return (React.createElement(Flex, { justifyContent: "flex-start", direction: "column" },
            React.createElement(H2, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.headerTwo" })),
            React.createElement(H4, { marginBottom: 2 },
                React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.headerFour.text" })),
            React.createElement(Flex, { justifyContent: "flex-start" },
                React.createElement(CircledConnector, { data: [
                        "renderCompFromProps",
                        formatMessage({ id: "admin.components.addPeopleCSV.circledConnector.data.fillInformation" }),
                        formatMessage({ id: "admin.components.addPeopleCSV.circledConnector.data.dragAndDrop" })
                    ], comp: React.createElement(DownloadCsvTemplate, null) })),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(DragAndDrop, { onDrop: onDrop }),
                    React.createElement(FieldsRecap, null)))));
    };
    return AddPeopleCSV;
}(PureComponent));
export default injectIntl(AddPeopleCSV);
